let refreshListByVoid = function(d) {	
	for (let i in this.InvoicesList) {
		if(this.InvoicesList[i] && this.InvoicesList[i].id == d.invoice_id) {
			this.InvoicesList[i].idxstatus = d.status;
			console.log('item refresh By Void', this.InvoicesList[i]);
		}
	}
};
export default refreshListByVoid;
